import { getMappableFieldMap } from "./mappable-fields.js";
/**
 * Header aliases used only for auto-suggest pre-fill.
 * Includes common Apollo export labels and generic synonyms — not runtime adapters.
 */
const COMPANY_HEADER_ALIASES = {
    "company name": "company_name",
    "company name for emails": "company_name_for_emails",
    "account stage": "account_stage",
    "# employees": "num_employees",
    employees: "num_employees",
    "employee count": "num_employees",
    industry: "industry",
    "account owner": "account_owner",
    website: "website",
    "company linkedin url": "social_urls.linkedin",
    linkedin: "social_urls.linkedin",
    "facebook url": "social_urls.facebook",
    "twitter url": "social_urls.twitter",
    "company street": "address.street",
    "company city": "address.city",
    "company state": "address.state",
    "company country": "address.country",
    "company postal code": "address.postal_code",
    "company address": "address.full_address",
    keywords: "keywords",
    "company phone": "company_phone",
    technologies: "technologies",
    "total funding": "financial_data.total_funding",
    "latest funding": "financial_data.latest_funding",
    "latest funding amount": "financial_data.latest_funding_amount",
    "last raised at": "financial_data.last_raised_at",
    "annual revenue": "financial_data.annual_revenue",
    "apollo account id": "external_ids.apollo_account_id",
    "apollo record id": "external_ids.apollo_record_id",
    "sic codes": "external_ids.sic_codes",
    "naics codes": "external_ids.naics_codes",
    "short description": "company_details.short_description",
    "founded year": "company_details.founded_year",
    "logo url": "company_details.logo_url",
    "subsidiary of": "company_details.subsidiary_of",
    "account notes": "qualification_data.account_notes",
    company_id: "company_id",
    company_name: "company_name",
};
const PERSON_HEADER_ALIASES = {
    "first name": "first_name",
    firstname: "first_name",
    "last name": "last_name",
    lastname: "last_name",
    name: "name",
    title: "title",
    "job title": "title",
    seniority: "seniority",
    departments: "departments",
    "sub departments": "sub_departments",
    "contact owner": "person_owner",
    "person owner": "person_owner",
    email: "email_data.primary_email",
    "email status": "email_data.primary_email_status",
    "primary email source": "email_data.primary_email_source",
    "secondary email": "email_data.secondary_email",
    "tertiary email": "email_data.tertiary_email",
    "work direct phone": "phone_data.work_direct_phone",
    "mobile phone": "phone_data.mobile_phone",
    "corporate phone": "phone_data.corporate_phone",
    "other phone": "phone_data.other_phone",
    "do not call": "phone_data.do_not_call",
    "company name": "company_data.company_name",
    "company name for emails": "company_data.company_name_for_emails",
    "# employees": "company_data.num_employees",
    industry: "company_data.industry",
    "account owner": "company_data.account_owner",
    keywords: "company_data.keywords",
    technologies: "company_data.technologies",
    "annual revenue": "company_data.annual_revenue",
    website: "company_data.website",
    "person linkedin url": "social_urls.person_linkedin_url",
    linkedin: "social_urls.person_linkedin_url",
    "profile url": "social_urls.person_linkedin_url",
    "company linkedin url": "social_urls.company_linkedin_url",
    "facebook url": "social_urls.facebook_url",
    "twitter url": "social_urls.twitter_url",
    city: "location_data.city",
    state: "location_data.state",
    country: "location_data.country",
    location: "location_data.country",
    "company address": "location_data.company_address",
    "company city": "location_data.company_city",
    "company state": "location_data.company_state",
    "company country": "location_data.company_country",
    "company phone": "location_data.company_phone",
    stage: "sales_activity.stage",
    lists: "sales_activity.lists",
    "last contacted": "sales_activity.last_contacted",
    "apollo contact id": "external_ids.apollo_person_id",
    "apollo person id": "external_ids.apollo_person_id",
    "apollo account id": "external_ids.apollo_account_id",
    "apollo record id": "external_ids.apollo_record_id",
    "sic codes": "company_data.sic_codes",
    "naics codes": "company_data.naics_codes",
    person_id: "person_id",
    company: "company_data.company_name",
};
function normalizeHeader(h) {
    return h.trim().toLowerCase().replace(/^"|"$/g, "");
}
export function suggestFieldMapping(entityType, headers) {
    const aliases = entityType === "company" ? COMPANY_HEADER_ALIASES : PERSON_HEADER_ALIASES;
    const catalog = getMappableFieldMap(entityType);
    const usedTargets = new Set();
    const entries = headers.map((csvColumn) => {
        const key = normalizeHeader(csvColumn);
        let targetPath = aliases[key] ?? null;
        // Exact path match (canonical export round-trip)
        if (!targetPath && catalog.has(key))
            targetPath = key;
        if (targetPath && usedTargets.has(targetPath))
            targetPath = null;
        if (targetPath)
            usedTargets.add(targetPath);
        const field = targetPath ? catalog.get(targetPath) : undefined;
        return {
            csvColumn,
            targetPath,
            transform: field?.type ?? "string",
        };
    });
    return { entityType, entries, listDelimiter: "," };
}
export function headerFingerprint(headers) {
    return headers.map(normalizeHeader).sort().join("|");
}
//# sourceMappingURL=suggest-mapping.js.map